import {makeStyles, Typography} from "@material-ui/core";
import {useEffect} from "react";
import {defaultWidth, padGinUnit, widthUnit} from "../../../utils/DeviceManager";
// @ts-ignore
import CurrencyInput from "react-currency-input";
import { AcnColorTheme } from "../../../assets/css/AcnColorTheme";
// import CurrencyInput from "react-currency-input-field";

interface PaymentCard {
    title: string;
    amount: string;
    callBack: any;
}


export function PaymentCard(props: PaymentCard) {
    const {title, amount} = props;

    useEffect(() => {

    }, []);

    const classes = useStyles();

    const dynamicFont = (num: number) => {
        const lng = amount.length
        if (lng <= 7) return num
        const lvl = (defaultWidth * 0.052);
        if (lvl >= num) return num
        return lvl
    }

    return (
        <div>
            <div className={classes.rectangle1}
                 onClick={() => {
                     props.callBack(amount)
                 }}>
                <Typography className={classes.content}>
                    {title}
                </Typography>
                <Typography className={classes.content2}>
                    <CurrencyInput
                        id={"input-amount-"+amount}
                        name={"input-amount-name-"+amount}
                        placeholder="0.00"
                        className={classes.inputCustom}
                        style={{fontSize: dynamicFont(32), maxWidth: widthUnit(200), width: widthUnit(200),
                            minWidth: widthUnit(200), textAlign: "end", paddingRight: padGinUnit(0)}}
                        value={amount}
                        precision="2"
                        disabled={true}
                        allowNegative={false}
                        selectAllOnFocus={false}
                        autoFocus={false}
                    />
                    {/* <CurrencyInput
                        id={"input-amount-"+amount}
                        name={"input-amount-name-"+amount}
                        placeholder="0.00"
                        disabled={true}
                        disableAbbreviations={false}
                        className={classes.inputCustom}
                        style={{fontSize: dynamicFont(32), maxWidth: widthUnit(200), width: widthUnit(200),
                            minWidth: widthUnit(200), textAlign: "end", paddingRight: padGinUnit(0)}}
                        defaultValue={amount}
                        value={amount}
                        decimalsLimit={2}
                        decimalScale={2}
                        fixedDecimalLength={2}
                        allowNegativeValue={false}
                    /> */}
                </Typography>

            </div>
        </div>
    )
}

const useStyles = makeStyles({
        inputCustom: {
            borderRadius: '0px',
            boxSizing: 'border-box',
            borderLeft: '0px solid #000000',
            borderRight: '0px solid #000000',
            borderTop: '0px solid #000000',
            borderBottom: '0px solid #000000',
            '&:hover': {
                borderRadius: '0px',
                borderLeft: '0px solid #F5333F',
                borderRight: '0px solid #F5333F',
                borderTop: '0px solid #F5333F',
                borderBottom: '0px solid #F5333F'
            },
            '&:focus': {
                borderRadius: '0px',
                borderLeft: '0px solid #F5333F',
                borderRight: '0px solid #F5333F',
                borderTop: '0px solid #F5333F',
                borderBottom: '0px solid #F5333F'
            },
            '&:disabled': {
                background: AcnColorTheme.white,
                color: AcnColorTheme.primaryBlack,
                borderRadius: '0px',
                borderLeft: '0px solid #F5333F',
                borderRight: '0px solid #F5333F',
                borderTop: '0px solid #F5333F',
                borderBottom: '0px solid #F5333F',
                opacity: 1
            }
        },
        rectangle1: {
            display: 'flex',
            justifyContent: 'space-between',
            paddingRight: '16px',
            height: '76px',
            alignItems: 'center',
            background: AcnColorTheme.white,
            borderRadius: '8px',
            boxSizing: 'border-box',
            margin: '8px 0',
            border: '2px solid #DADDDF',
            '&:hover': {
                border: '2px solid #F5333F',
                background: AcnColorTheme.white,
            }
        },
        content: {
            padding: '8px',
            fontFamily: 'Thonburi',
            fontSize: 18,
            fontWeight: 'bold'
        },
        content2: {
            padding: '8px',
            fontSize: 32,
            fontWeight: 'normal'
        },
        fee: {
            fontSize: '14px',
            color: AcnColorTheme.darkGrey,
        },
        img: {
            width: '40px',
            height: '40px',
            borderRadius: ' 50%',

        }
    },
    {name: 'PaymentCard'});